import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import CustomButton from '../../../common/components/UI/Button/Button';
import SearchInput from '../../../common/components/UI/Search/SearchInput';
import './RuleSet.scss';

/**
 * 
 * @param {{
 *  searchValue: string,
 *  setSearchValue: Function,
 *  onCreate: Function,
 * }} props 
 * @returns 
 */
function RuleSetHeader(props){
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings'});
    const { searchValue, setSearchValue, onCreate } = props;
    return (
        <div className="rsh-header">
            <div className="create-new-button-container">
                <CustomButton
                    size={'medium'}
                    color={'primary'}
                    sx={{
                        width: '200px',
                        textTransform: 'capitalize',
                        '&.primary': {
                            backgroundColor: 'var(--B400)',
                            '& svg path': { fill: 'white' },
                            '&:hover': {
                                backgroundColor: '#2347B2',
                                '& svg path': { fill: 'white' },
                            },
                        },
                    }}
                    onClick={onCreate}
                >
                    <FontAwesomeIcon icon={faPlusCircle} />
                    {t('ruleSet.addNew')}
                </CustomButton>
            </div>
            <div className="search-input-container">
                <SearchInput
                    fullWidth={true}
                    value={searchValue}
                    placeholder={t('search')}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>
        </div>
    );
}
export default RuleSetHeader;
